// @flow

import * as React from 'react';
import Modal from './Modal';
import type { Props as ModalProps } from './Modal';

type Props = {|
  /** The percentage height of the viewport to use. */
  vh: number,
  /** The percentage width of the viewport to use. */
  vw: number,
  /** Props to pass to the Modal.  See OuterProps in Modal.jsx for more information. */
  ...ModalProps,
|};

/**
 * Composes the Modal component with an inner div that sets the height and width respective to the size of the viewport.
 * @deprecated  Use @ta/modal.styleguide with a custom width/height prop
 */
const ViewportRelativeModal = (props: Props) => {
  const { vh, vw, ...modalProps } = props;
  return (
    <Modal {...modalProps}>
      <div style={{ height: `${vh}vh`, width: `${vw}vw` }}>{props.children}</div>
    </Modal>
  );
};
ViewportRelativeModal.defaultProps = {
  vh: 70,
  vw: 80,
};
export default ViewportRelativeModal;
